var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sentry-__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m103 232 8 8v19c-21 25 24 28 63 48l-16-32 11-2 13 45H98v-83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251 236-8 9v17c23 21-26 34-57 46l11-33-10-2-7 47h83v-82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174 310 6.775 2.055L186 311l1 2-6 4-8-3Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sentry-__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h350v350H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 38c54 0 83 41 86 90 0 10 4 22 9 34l-14 22-12 34-1 14c-24 37-36 51-55 51h-18c-23 0-47-37-58-54v-9l-15-36-13-23c2-8 5-17 9-25-3-52 30-98 82-98"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8e2d",
    d: "m54 99 1-2 4 1 15-17 25 8 141-18 22-4-15 21 34-22 10-2v26l-30 9 4 3v2l28 2v20l-11 2-21-1-167 2H72l-17-2-1-12 27-8-27-2Zm17 33h7l8 7 175-2h20l1 3-17 4 17 1-1 28h2v8l-11 4-15 1-9 10 20-1 12 1 2 3h14l-2 26-20-2 19 9-1 11-3-1-14-2-7-5h-6l-2-1-12-1-140-17-23-5-21 3-8-8-1-20 17 2-19-11-1-16 12 2h15l-1-3-7-1Zm-12 89 25 4 24-2 135 22h14l10-5 8 5-2 5 4 3 11-1 4 3h9l-3 6-16-1 7 3h8l-6 14-52 3 51 1-4 8-44-4-132-9-40 3-9-7v-7l2-4 33-1-34-2v-2l2-1 1-7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104 209v49c-17 30 23 38 77 56 51-18 86-29 70-55v-50Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M104 209v49c-17 30 23 38 77 56 51-18 86-29 70-55v-50Z",
    clipPath: "url(#sentry-__a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175 30c61 0 90 49 92 98 0 11 5 22 10 33-3 10-9 19-14 24-15 61-49 104-75 104h-18c-18 0-60-40-82-104-5-7-10-16-13-25 3-10 6-18 10-27 2-58 39-103 90-103"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M175 30c61 0 90 49 92 98 0 11 5 22 10 33-3 10-9 19-14 24-15 61-49 104-75 104h-18c-18 0-60-40-82-104-5-7-10-16-13-25 3-10 6-18 10-27 2-58 39-103 90-103",
    mask: "url(#sentry-__b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102 130c0-56 40-90 88-82-73 13-67 64-26 82Zm0 15 151-7 3 6Zm7 11h135v15c0 19-18 41-38 42-6-10-19-17-31-21-12 4-25 11-31 21-17-1-35-23-35-42Zm19 84 23 19h56l22-18-12 16-12 11-11 7 5-8h-40l4 7-9-5-13-11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentry);
export default __webpack_public_path__ + "static/media/sentry.f109510caac7ee420093141509fe9600.svg";
export { ForwardRef as ReactComponent };